import axios from 'axios'
import { stringify } from 'query-string'

import type { AxiosInstance, AxiosRequestConfig } from 'axios'

export const baseUrl =
  process.env.NEXT_PUBLIC_API_URL ?? 'https://api.staging.belajar.id'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

const paramsSerializer = (params?: Record<string, any>): string =>
  stringify(params ?? {}, { arrayFormat: 'none' })

export const api = (opts?: AxiosRequestConfig): AxiosInstance => {
  return axios.create({
    baseURL: baseUrl,
    headers,
    paramsSerializer: { serialize: paramsSerializer },
    ...(opts ?? {}),
  })
}
